import {
  INVESTMENT_TRUST_TYPE,
  PORTFOLIO_ASSET_TYPE,
  PORTFOLIO_BENCH_MARK,
} from './portfolioInfo';

export type TargetAccountItem = {
  account: AccountId;
  brokerName: string;
  available: boolean;
  totalAssetAmount: number;
};

// TODO: 型の妥当性を最後に確認する
export type Target = {
  id: string;
  title: string;
  refType: TargetType;
  startDate: string;
  endDate: string;
  targetAmount: number;
  accountList: Array<TargetAccountItem>;
  excludeAmount: number;
  reserveAmount: number;
  assetAmount: number;
  yield: number;
  achieved: boolean;
  status?: TargetModalStatus;
};

export type TargetId = string;

export type TargetTitle = string;

export type CurrentAmount = number;

export type TargetAmount = number;

export type MonthProps = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type GlobalTargetProps = {
  id: string;
  title: string;
  startDate: Date;
  endDate: Date;
  targetAmount: number;
  targetYield?: number | null;
  refType: number;
  accountIDList?: Array<string>;
  excludeAmount?: number;
  reserveAmount?: number;
  managementType?: number;
};

export type TargetType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17;

export type TargetTypes = {
  targetType: TargetType;
  accounts?: string[];
  isRecommendMark?: boolean;
  title: string;
  roughTargetAmount: number | null;
  description: string;
  subTitle: string;
  sort: number;
};

// 現金でつみたて
export const howToSaveCash = 1 as const;

// 投資商品で運用
export const howToSaveInvestmentProducts = 2 as const;

export type HowToSaveType =
  | typeof howToSaveCash
  | typeof howToSaveInvestmentProducts;

export type AssetTransitions = {
  assetAmount: number;
  dateYM: string;
};

export type AccountId = string;

export type Account = {
  account: AccountId;
  brokerName: string;
  totalAssetAmount: number;
  aggregateSource: number;
  available: boolean;
  brokerType: number;
};

export type TargetModalStatus = 0 | 2 | 3 | 4 | 5 | 6;

export type PortfolioAnalysisItem = {
  assetType: PortfolioAssetType;
  currentPer: number;
  targetPer: number;
};

export type ManagementItems = {
  managementType: ManagementType;
  itemsByPortfolioAnalysis: Array<PortfolioAnalysisItem>;
};

export type PortfolioAnalysis = {
  itemsByPortfolioAnalysis: Array<PortfolioAnalysisItem>;
  registeredAccountName: Array<string>;
  targetReturnPer: number;
  targetReturnLimitPer: number;
  updateDateOfAsset: string;
  managementType: ManagementType;
  managementItems: Array<ManagementItems>;
};

export type PortfolioAssetType = typeof PORTFOLIO_ASSET_TYPE[keyof typeof PORTFOLIO_ASSET_TYPE]['type'];

export type PortfolioBenchMark = typeof PORTFOLIO_BENCH_MARK[keyof typeof PORTFOLIO_BENCH_MARK]['type'];

export type TargetHistoryTransitionData = {
  assetAmount: number;
  benchmarkAmount: number;
  date: string;
  incorrect: boolean;
};

export type History = {
  id: string;
  achievementAmount: number;
  targetAmount: number;
  from: string;
  to: string;
  transitions: Array<TargetHistoryTransitionData>;
};

export type InvestmentTrustType = typeof INVESTMENT_TRUST_TYPE[keyof typeof INVESTMENT_TRUST_TYPE]['type'];

export type InvestmentTrust = {
  id: string;
  name: string;
  trustFeePercentage: number;
  standardPriceDate: Date;
  standardPrice: number;
  salesCompany: string[];
  annualReturnPercentage: number | null;
  isHeld: boolean;
  type: InvestmentTrustType;
};

export type InvestmentTrustFundByAssetItem = {
  investmentType: string;
  held: boolean;
  oneYearReturnPer: number | null;
  salesCompany: Array<string>;
  standardPrice: number;
  standardPriceDate: string;
  symbol: string;
  symbolName: string;
  trustFeePer: number;
};

export type InvestmentTrustFund = {
  itemsByInvestmentType: Array<InvestmentTrustFundByAssetItem>;
  assetType: PortfolioAssetType;
  benchMark: string;
  currentPer: number;
  dissociatePer: number;
  targetPer: number;
  targetPurchaseAmount: number;
};

export const ManagementTypeItem = {
  アセプラ5: 1,
  アセプラ8: 2,
  株式のみ: 3,
  景気拡大: 4,
  景気縮小: 5,
  国内強気: 6,
  先進国強気: 7,
  新興国強気: 8,
} as const;

export type ManagementType = typeof ManagementTypeItem[keyof typeof ManagementTypeItem];

export type ManagementItem = {
  managementType: ManagementType;
  itemsByPortfolioAnalysis: PortfolioAnalysisItem[];
};
